<script>
    import { createEventDispatcher } from "svelte";
    import Form from "./Form.svelte";

    import { VStack } from "../component/layout";
    import { TextArea } from "./widget";
    import { create } from "../contact.js";

    export let wedding_guid;

    const dispatch = createEventDispatcher();

    let step = 1;
    let steps = [
        {
            id: 1,
            name: "Message",
            done: false,
            back: false,
            cancel: true,
            submit: "validate",
            next: 2,
            prev: null,
        },
        {
            id: 2,
            name: "Félicitations",
            done: false,
            back: false,
            cancel: false,
            submit: "final",
            next: null,
            prev: 1,
        },
    ];

    let form = undefined;

    let current = "";
    let comment = null;

    const submit = async () => {
        if (step == 1) {
            await create(wedding_guid, comment);
        } else if (step == 2) {
            dispatch("close");
        }
    };

    function validate(event) {
        switch (event.target.name) {
            case "c1":
                break;
            default:
                break;
        }
    }
</script>

<Form
    bind:form
    bind:step
    bind:steps
    {submit}
    {validate}
    validateButton={"Confirmer"}
    backButton={"Retour"}
    on:close
    padding={false}>
    <article>
        {#if step == 1}
            <VStack>
                <p>Veuillez saisir votre message ci-dessous.</p>
                <TextArea
                    id={"comment"}
                    reset
                    required
                    bind:value={comment}
                    icon="fas fa-edit"
                    label="Commentaire"
                    placeholder="Un petit message aux futures mariés ?"
                    bind:current />
            </VStack>
        {:else if step == 2}
            <VStack>
                <h1>Félicitations !</h1>
                <p>Votre message a bien été validé.</p>
            </VStack>
        {/if}
    </article>
</Form>

<style>
    article {
        height: 250px;
        width: 480px;
    }

    @media screen and (max-width: 600px) {
        article {
            width: 100%;
        }
    }

    h1 {
        font-family: "Cinzel";
        font-size: 1.5rem;
        text-align: center;
    }
</style>
